// Brand configuration system
// Controlled by REACT_APP_BRAND environment variable (default: 'indieviral')

export interface BrandFeatures {
  showGamedevFeatures: boolean;
  showSteamEvents: boolean;
  showDailyMissions: boolean;
  showGamification: boolean;
  showProjects: boolean;
}

export interface BrandPlanNames {
  basic: string;
  pro: string;
  agency: string;
}

export interface BrandConfig {
  id: string;
  name: string;
  domain: string;
  email: string;
  tagline: string;
  description: string;
  logo: string;
  telegramBot: string;
  turnstileSiteKey: string;
  themeStorageKey: string;
  stateStorageKey: string;
  defaultTheme: 'dark' | 'olive';
  planNames: BrandPlanNames;
  features: BrandFeatures;
}

const indieviral: BrandConfig = {
  id: 'indieviral',
  name: 'IndieViral',
  domain: 'indieviral.com',
  email: 'admin@indieviral.com',
  tagline: 'The Social Media Manager Built for Indie Gamedevs',
  description: 'Schedule and publish your devlogs, trailers and screenshots to X/Twitter, TikTok, Bluesky, Instagram and Threads from one dashboard. Built for indie gamedevs.',
  logo: '/logosquare.png',
  telegramBot: 'indieviral_bot',
  turnstileSiteKey: '0x4AAAAAACWebGRrYq39SGa-',
  themeStorageKey: 'gamedev-theme',
  stateStorageKey: 'gamedev-promoter-global-state',
  defaultTheme: 'dark',
  planNames: {
    basic: 'Basic',
    pro: 'Indie',
    agency: 'Publishers',
  },
  features: {
    showGamedevFeatures: true,
    showSteamEvents: true,
    showDailyMissions: true,
    showGamification: true,
    showProjects: true,
  },
};

const postpresto: BrandConfig = {
  id: 'postpresto',
  name: 'PostPresto',
  domain: 'postpresto.com',
  email: 'admin@postpresto.com',
  tagline: 'Your Social Media Manager — Fast, Simple, Everywhere',
  description: 'Schedule and publish to X/Twitter, TikTok, Bluesky, Instagram and Threads from one dashboard. Save hours on social media marketing.',
  logo: '/logosquare.png',
  telegramBot: 'postpresto_bot',
  turnstileSiteKey: '0x4AAAAAAChFqi94tK4N1WmK',
  themeStorageKey: 'postpresto-theme',
  stateStorageKey: 'postpresto-global-state',
  defaultTheme: 'olive',
  planNames: {
    basic: 'Basic',
    pro: 'Creator',
    agency: 'Business',
  },
  features: {
    showGamedevFeatures: false,
    showSteamEvents: false,
    showDailyMissions: false,
    showGamification: false,
    showProjects: false,
  },
};

const brands: Record<string, BrandConfig> = {
  indieviral,
  postpresto,
};

const brandId = process.env.REACT_APP_BRAND || 'indieviral';

export const brand: BrandConfig = brands[brandId] || indieviral;

export function getBrand(): BrandConfig {
  return brand;
}
